import { render, staticRenderFns } from "./CommandCenterDialog.vue?vue&type=template&id=458e3d28"
import script from "./CommandCenterDialog.vue?vue&type=script&lang=ts"
export * from "./CommandCenterDialog.vue?vue&type=script&lang=ts"
import style0 from "./CommandCenterDialog.vue?vue&type=style&index=0&id=458e3d28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports